var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPatientsManagement24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1.667c-4.517 0-8.333 3.816-8.333 8.333 0 2.658 1.326 5.065 3.333 6.603v.064h.085c1.39 1.037 3.093 1.666 4.915 1.666 1.823 0 3.525-.629 4.915-1.666H15v-.064c2.007-1.538 3.333-3.945 3.333-6.603 0-4.517-3.815-8.333-8.333-8.333zM6.728 15.773c.248-1.121 1.245-1.962 2.439-1.962h1.666c1.194 0 2.191.842 2.439 1.962-.974.564-2.092.894-3.272.894-1.18 0-2.298-.33-3.272-.894zm7.947-1.072c-.63-1.5-2.115-2.557-3.842-2.557H9.167c-1.727 0-3.212 1.058-3.842 2.557C4.103 13.485 3.333 11.813 3.333 10c0-3.614 3.053-6.667 6.667-6.667S16.667 6.386 16.667 10c0 1.813-.77 3.485-1.992 4.7z",
    transform: "translate(-24 -164) translate(0 70) translate(24 94)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 5C8.1 5 6.667 6.433 6.667 8.333c0 1.9 1.433 3.334 3.333 3.334 1.9 0 3.333-1.434 3.333-3.334C13.333 6.433 11.9 5 10 5zm0 5c-.982 0-1.667-.685-1.667-1.667 0-.981.685-1.666 1.667-1.666s1.667.685 1.667 1.666C11.667 9.315 10.982 10 10 10z",
    transform: "translate(-24 -164) translate(0 70) translate(24 94)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPatientsManagement24);
export default __webpack_public_path__ + "static/media/ic-patients-management-24.650aa338.svg";
export { ForwardRef as ReactComponent };